import { Space, SubText, WithTooltip } from '@procurify/ui'
import { IconAttention } from '@procurify/ui'

import { CatalogItemIndicator } from '@webapp/components/CatalogItemIndicator'
import { OrderItemTypeTag } from '@webapp/components/OrderItemTypeTag'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const ItemDescriptionQuantityCell = ({
  description,
  isCatalogItem,
  quantity,
  itemType,
  isRequestingFromDifferentVendor,
}: ColumnTypeData['ITEM_DESCRIPTION_QUANTITY']) => {
  const intl = useProcurifyIntl()

  return (
    <Space size='xsmall'>
      <div>
        <SubText inline bold>
          {isCatalogItem && <CatalogItemIndicator />} {description}
          {isRequestingFromDifferentVendor && (
            <>
              {' '}
              <WithTooltip
                title={intl.formatMessage(messages.differentVendorTooltip)}
                placement='top'
              >
                <WithTooltip.Wrapper>
                  <IconAttention
                    color='red'
                    aria-label={intl.formatMessage(
                      messages.differentVendorIconAriaLabel
                    )}
                  />
                </WithTooltip.Wrapper>
              </WithTooltip>
            </>
          )}
        </SubText>
      </div>
      {quantity && (
        <span>
          {intl.formatMessage(messages.quantityLabel)}: {quantity || '--'}
        </span>
      )}
      {itemType && <OrderItemTypeTag itemType={itemType} />}
    </Space>
  )
}
